<template>
  <el-drawer
    :visible.sync="drawerVisible"
    :with-header="false"
    size="600px"
    direction="rtl"
    :before-close="handleClose"
    append-to-body
  >
    <div class="banner-detail-container">
      <div class="drawer-header">
        <div class="drawer-title">banner详情</div>
        <i class="el-icon-close close-icon" @click="handleClose"></i>
      </div>

      <div class="detail-content" v-loading="loading">
        <div class="section">
          <div class="section-title">基本信息</div>
          <div class="detail-item">
            <div class="item-label">banner名称</div>
            <div class="item-value">{{ bannerInfo.name }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">所属广告组</div>
            <div class="item-value">{{ bannerInfo.bannerGroupName }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">选用模板</div>
            <div class="item-value">
              {{
                bannerInfo.templateId === 1
                  ? '模板一：1*4 banner位'
                  : bannerInfo.templateId === 2
                  ? '模板二：1+2 banner位'
                  : bannerInfo.templateId === 3
                  ? '模板三：2+1 banner位'
                  : bannerInfo.templateId === 4
                  ? '模板四：单行banner位'
                  : '-'
              }}
            </div>
          </div>
          <div class="detail-item">
            <div class="item-label">组内位置</div>
            <div class="item-value">{{ bannerInfo.slotKey || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">展示时间</div>
            <div class="item-value">{{ bannerInfo.startTime }} 至 {{ bannerInfo.endTime }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">权重</div>
            <div class="item-value">{{ bannerInfo.sort }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">展示地区</div>
            <div class="item-value">
              <template v-if="bannerInfo.allArea === 1">全部地区</template>
              <template
                v-else-if="
                  bannerInfo.advertisingAreaVoList && bannerInfo.advertisingAreaVoList.length
                "
              >
                {{ formatAreas(bannerInfo.advertisingAreaVoList) }}
              </template>
              <template v-else>部分地区</template>
            </div>
          </div>
          <div class="detail-item">
            <div class="item-label">展示渠道</div>
            <div class="item-value">{{ formatDisplayChannel(bannerInfo.displayChannel) }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">展示页面</div>
            <div class="item-value">
              {{
                bannerInfo.displayPageKey === 0
                  ? '首页'
                  : bannerInfo.displayPageKey === 1
                  ? '城际出行页'
                  : bannerInfo.displayPage || '-'
              }}
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">banner预览</div>
          <div class="preview-box">
            <div v-if="bannerInfo.templateId === 1" class="preview">
              <div>
                <img :src="bannerInfo.marketImgUrl" alt="" />
              </div>
              <div>
                <img :src="bannerInfo.imgUrl" alt="" />
              </div>
              <div>{{ bannerInfo.marketText }}</div>
            </div>
            <div v-else class="preview">
              <img :src="bannerInfo.imgUrl" alt="" />
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">默认广告预览</div>
          <div class="preview-box">
            <div v-if="bannerInfo.templateId === 1" class="preview">
              <div>
                <img :src="bannerInfo.defaultMarketImgUrl" alt="" />
              </div>
              <div>
                <img :src="bannerInfo.defaultMarketFontUrl" alt="" />
              </div>
              <div>{{ bannerInfo.defaultMarketText }}</div>
            </div>
            <div v-else class="preview">
              <img :src="bannerInfo.defaultMarketImgUrl" alt="" />
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">页面跳转</div>
          <div class="detail-item">
            <div class="item-label">跳转页面</div>
            <a
              class="item-value"
              style="color: #0a85f8"
              :href="bannerInfo.pageUrl"
              v-if="bannerInfo.pageUrl"
              >{{ bannerInfo.pageUrl || '-' }}</a
            >
            <div v-else>-</div>
          </div>
          <div class="detail-item">
            <div class="item-label">跳转类型</div>
            <div class="item-value">{{ getPageUrlTypeText(bannerInfo.pageUrlType) }}</div>
          </div>
          <!--          <div class="detail-item" v-if="bannerInfo.pageUrlType === 3">-->
          <!--            <div class="item-label">appId</div>-->
          <!--            <div class="item-value">{{ bannerInfo.appId || '-' }}</div>-->
          <!--          </div>-->
          <!--          <div class="detail-item" v-if="bannerInfo.pageUrlType === 3">-->
          <!--            <div class="item-label">账号原始ID</div>-->
          <!--            <div class="item-value">{{ bannerInfo.appletOriginalId || '-' }}</div>-->
          <!--          </div>-->
        </div>

        <div class="section">
          <div class="section-title">其他信息</div>
          <div class="detail-item">
            <div class="item-label">创建人</div>
            <div class="item-value">{{ bannerInfo.createUser || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">创建时间</div>
            <div class="item-value">{{ bannerInfo.createTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">审核人</div>
            <div class="item-value">{{ bannerInfo.auditUser || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">审核时间</div>
            <div class="item-value">{{ bannerInfo.auditTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">更新人</div>
            <div class="item-value">{{ bannerInfo.updateUser || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">更新时间</div>
            <div class="item-value">{{ bannerInfo.updateTime || '-' }}</div>
          </div>
          <div class="detail-item">
            <div class="item-label">广告状态</div>
            <div class="item-value">
              <el-tag :type="renderStatusTag(bannerInfo.status).type" size="small">
                {{ renderStatusTag(bannerInfo.status).text }}
              </el-tag>
            </div>
          </div>
          <div class="detail-item" v-if="bannerInfo.status === 2">
            <div class="item-label">拒绝原因</div>
            <div class="item-value red-text">{{ bannerInfo.refuseReason || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import { getBannerDetail } from '@/api/footerBanner'

  export default {
    name: 'BannerDetail',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      bannerId: {
        type: [String, Number],
        default: ''
      }
    },
    data() {
      return {
        displayChannelMap: {
          1: '微信小程序',
          2: 'APP',
          3: '云闪付',
          4: '支付宝小程序'
        },
        loading: false,
        bannerInfo: {}
      }
    },
    computed: {
      drawerVisible: {
        get() {
          return this.visible
        },
        set(val) {
          this.$emit('update:visible', val)
        }
      }
    },
    watch: {
      visible(val) {
        if (val && this.bannerId) {
          this.fetchBannerDetail()
        }
      }
    },
    methods: {
      handleClose() {
        this.drawerVisible = false
      },

      // 获取banner详情
      async fetchBannerDetail() {
        if (!this.bannerId) return

        this.loading = true
        try {
          const res = await getBannerDetail(this.bannerId)
          if (res.data) {
            this.bannerInfo = res.data
          } else {
            this.$message.error('获取banner详情失败')
          }
        } catch (error) {
          console.error('获取banner详情失败:', error)
          this.$message.error('获取banner详情失败')
        } finally {
          this.loading = false
        }
      },

      // 格式化展示渠道
      formatDisplayChannel(channels) {
        if (!channels) return '-'
        return channels
          .split(',')
          .map((ch) => this.displayChannelMap[ch] || ch)
          .join('、')
      },

      // 获取跳转类型文本
      getPageUrlTypeText(type) {
        const typeMap = {
          1: '乘客端内部页面',
          2: '外部链接',
          3: '其他小程序'
        }
        return typeMap[type] || '-'
      },

      // 渲染状态标签
      renderStatusTag(status) {
        const statusMap = {
          1: { type: 'primary', text: '待审核' },
          2: { type: 'danger', text: '未通过' },
          3: { type: 'info', text: '未开始' },
          4: { type: 'success', text: '进行中' },
          5: { type: 'warning', text: '已下架' }
        }
        return statusMap[status] || { type: '', text: status }
      },

      // 格式化展示地区
      formatAreas(areas) {
        if (!areas || !areas.length) return '-'
        return areas.map((area) => area.name).join(',')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .banner-detail-container {
    height: 100%;
    display: flex;
    flex-direction: column;

    .drawer-header {
      padding: 16px 20px;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .drawer-title {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
      }

      .close-icon {
        font-size: 18px;
        cursor: pointer;
        color: #909399;

        &:hover {
          color: #409eff;
        }
      }
    }

    .detail-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;

      .section {
        margin-bottom: 24px;

        .section-title {
          font-size: 15px;
          font-weight: 500;
          color: #303133;
          margin-bottom: 16px;
          position: relative;
          padding-left: 10px;

          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 14px;
            background-color: #409eff;
            border-radius: 2px;
          }
        }

        .detail-item {
          display: flex;
          margin-bottom: 12px;
          font-size: 14px;
          line-height: 1.5;

          .item-label {
            width: 100px;
            color: #606266;
            flex-shrink: 0;
          }

          .item-value {
            color: #303133;
            word-break: break-all;
          }
        }

        .banner-preview {
          .banner-img-container {
            width: 100%;
            background-color: #f5f7fa;
            border-radius: 4px;
            overflow: hidden;
            margin-bottom: 12px;

            .banner-img {
              width: 100%;
              display: block;
            }
          }

          .banner-placeholder {
            width: 100%;
            height: 150px;
            background-color: #f5f7fa;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 12px;

            .placeholder-text {
              color: #909399;
              font-size: 14px;
            }
          }

          .banner-note {
            background-color: #f5f7fa;
            padding: 12px;
            border-radius: 4px;

            .note-text {
              font-size: 12px;
              color: #606266;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }

  .red-text {
    color: #f56c6c;
  }

  .preview-box {
    margin: 0 40px 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .preview-text {
    color: #f56c6c;
    margin-bottom: 15px;

    p {
      margin: 5px 0;
    }
  }

  .banner-images {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .image-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        margin-bottom: 10px;
        font-weight: 500;
      }

      .market-text {
        padding: 10px;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        min-width: 150px;
        text-align: center;
      }
    }
  }
  .preview {
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    max-width: 400px;
    img {
      width: 100%;
    }
  }
</style>
